// extracted by mini-css-extract-plugin
export default {"featuredbanner__wrapper":"featuredbanner_featuredbanner__wrapper__XPIY7","image_container":"featuredbanner_image_container__uOikn","image":"featuredbanner_image__ssHP3"};